import {createContext, useReducer, Dispatch, ReactNode} from 'react';

const initialState: CandidateStateProps = {
	name: null,
	lastname: null,
	middleName: null,
	id: null,
	email: null,
	path: null,
	registrationNumber: null,
	curriculumPayment: false,
	telephone: null,
	status: 'Ընթացքի մեջ',
	statusID: 1,
	exams: []
};

export interface CandidateStateProps {
	name: null | string;
	lastname: null | string;
	middleName: null | string;
	id: null | number;
	email: null | string;
	registrationNumber: null | string;
	curriculumPayment: boolean;
	path: string | null;
	telephone: null | string;
	status: string;
	statusID: (1 | 2 | 3) | number;
	exams: any[];
}

type Action =
	| {type: 'SET_STATUS'; payload: {status: string; statusID: 1 | 2 | 3}}
	| {type: 'LOGOUT'}
	| {
			type: 'SET_PROFILE';
			payload: {
				name: string;
				lastname: string;
				middleName: string;
				telephone: string;
				id: number;
				email: string;
				path: string | null;
				status: string;
				registrationNumber: string;
				curriculumPayment: boolean;
				statusID: 1 | 2 | 3;
			};
	  };

interface InitContextProps {
	state: CandidateStateProps;
	dispatch: Dispatch<Action>;
}

export const CandidateContext = createContext({} as InitContextProps);

const reducer = (state: CandidateStateProps, action: Action) => {
	switch (action.type) {
		case 'SET_STATUS':
			return {
				...state,
				status: action.payload.status,
				statusID: action.payload.statusID ?? 1
			};
		case 'SET_PROFILE':
			return {
				...state,
				name: action.payload.name,
				lastname: action.payload.lastname,
				middleName: action.payload.middleName,
				telephone: action.payload.telephone,
				path: action.payload.path,
				id: action.payload.id,
				email: action.payload.email,
				registrationNumber: action.payload.registrationNumber,
				status: action.payload.status,
				statusID: action.payload.statusID,
				curriculumPayment: action.payload.curriculumPayment
			};
		case 'LOGOUT': {
			return initialState;
		}
		default:
			return state;
	}
};

const CandidateProvider = ({children}: {children: ReactNode}) => {
	const [state, dispatch] = useReducer(reducer, initialState);
	const value = {state, dispatch};

	return <CandidateContext.Provider value={value}>{children}</CandidateContext.Provider>;
};

export default CandidateProvider;
